import Card from '@mui/material/Card';
import { FC, ReactNode } from 'react';
import "../../scss/common.scss";
import './global-card.scss';

const GlobalCard:FC<{classNames?:string, id?:string,children: ReactNode}> = (props) => {
  const {classNames,id} = props;
  return (
    <div className='global-card-wrapper' >
      <Card id={id} className={`Global_card br-10 ${classNames}`}>
        {props.children}
      </Card>
    </div>
  );
};

export default GlobalCard;
